export default __webpack_public_path__ + "static/media/bepaid_logos_mb.2f1ddaf6.png";